import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 7.72,
	height: 7.72,
	viewBox: "0 0 7.72 7.72",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Path_700",
		"data-name": "Path 700",
		d: "M3.36,0A3.36,3.36,0,1,1,0,3.36,2.677,2.677,0,0,1,.982.939",
		transform: "translate(7.22 0.5) rotate(90)",
		fill: "none",
		stroke: "#fff",
		strokeLinecap: "round",
		strokeWidth: 1
	})]
});
const ForwardRef = forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
